<template>
        <img class="avatar" :src="imgSrc" :width="width" v-bind:class="{contributor : isFriend}">
</template>

<script>
    export default {
        name: 'elv-avatar-icon',
        props: { 'avatar': {required:true},
            'width': {default: 24, required: false},
            'isFriend': {required: false, default: false}
        },
        data () {
            return {
            }
        },
        computed: {
            imgSrc: {
                get: function() {
                    if( this.avatar ) {
                        return "/static/img/avatars/" + this.avatar + ".png";
                    }
                    else {
                        return "/static/img/avatars/no-avatar.png";
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .contributor {
            /* NICE BLUR */
            -webkit-box-shadow: 0 0 10px 2px #FFD700;
            -moz-box-shadow: 0 0 10px 2px #FFD700;
            box-shadow: 0 0 10px 2px #FFD700;

            /* SOLID CIRCLE */
            /*
            -webkit-box-shadow: 0 0 0px 4px #FFD700;
            -moz-box-shadow: 0 0 0px 4px #FFD700;
            box-shadow: 0 0 0px 4px #FFD700;
            */
    }
    h2 .contributor {
            /* NICE BLUR */
            -webkit-box-shadow: 0 0 20px 2px #FFD700;
            -moz-box-shadow: 0 0 20px 2px #FFD700;
            box-shadow: 0 0 20px 2px #FFD700;
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvAvatarIcon.vue